/**
 * A mock interface for the OPLTY_X SCS
 * See https://github.com/optimizely/optimizely/tree/devel/src/www/frontend/src/js/bundles/p13n
 */
import React, { useEffect, useState } from 'react';

const MOCK_AUDIENCES = ['or', { audience_id: 5340810295 }];

const MOCK_METRICS = [
  {
    aggregator: 'sum',
    display_title: 'Increasing Revenue by Session',
    event_id: 32334454244,
    event_properties: {
      filter: {
        combine_operator: 'or',
        conditions: [
          {
            name: 'currency',
            operator: 'equal_to',
            type: 'string',
            value: 'EUR',
          },
        ],
      },
    },
    field: 'revenue',
    scope: 'session',
    winning_direction: 'increasing',
  },
];

const NON_UNIQUE_CONVERSION_MOCK_METRICS = [
  {
    aggregator: 'count',
    display_title: 'Increasing Total by Session',
    event_id: 32334454244,
    scope: 'session',
    winning_direction: 'increasing',
  },
];

export const AudienceCombinationsBuilderWithData = (props: {
  audienceConditions: any;
  canEditAudience: boolean;
  onChange: (...args: any) => any;
  projectId: number;
}) => {
  const [audienceConditionsLocal, setAudienceConditionsLocal] = useState(
    JSON.stringify(props.audienceConditions)
  );
  useEffect(() => {
    setAudienceConditionsLocal(JSON.stringify(props.audienceConditions));
  }, [props.audienceConditions]);
  return (
    <div
      data-test-section={
        props.canEditAudience ? 'audience-combinations-can-edit-audience' : ''
      }>
      <textarea
        onBlur={e => {
          props.onChange({
            audienceConditions: JSON.parse(audienceConditionsLocal),
          });
        }}
        onChange={e => {
          setAudienceConditionsLocal(e.target.value);
        }}
        style={{ height: '100px', width: '100%' }}
        value={audienceConditionsLocal}
      />
      <button
        className="push-half--top"
        onClick={() =>
          props.onChange({
            audienceConditions: MOCK_AUDIENCES,
          })
        }>
        Add mock audience
      </button>
    </div>
  );
};

export const AudienceCombinationsName = ({
  audienceConditions,
}: {
  audienceConditions: any;
}) => {
  return <span>{JSON.stringify(audienceConditions)}</span>;
};

export const AudienceSearchPicker = () => {
  return <span>MOCK AudiencesSearchPicker Component</span>;
};

export const ChangeHistory = (props: {
  changeHistoryLimit?: number;
  currentProjectCreatedDate?: string;
  currentProjectId?: number;
  currentProjectType?: string;
  customEntityTypes: string[];
  hasAllEntities?: boolean;
  /** List of entityType:entityId pairs (experiment:id, event:id etc.) for initial filters on mount */
  initialEntityFilter?: string[];
  /** List of UiEntityTypes ('personalization', 'multivariate_test', 'experiment', 'event' etc.) for initial filters on mount */
  initialTypeFilter?: string[];
  isGaeAdmin?: boolean;
  track?: (eventName: string, options?: {}) => void;
  uiStyle?: string;
}) => {
  return <div>{JSON.stringify(props)}</div>;
};

export const EventsAndMetricsBuilderWithData = (props: {
  disablePrimaryMetricEdit: boolean;
  distributionMode?: string;
  experimentType?: string;
  isDisabled: boolean;
  onChange: (...args: any) => any;
  selectedMetrics: any;
}) => {
  const [metricsLocal, setMetricsLocal] = useState(
    JSON.stringify(props.selectedMetrics)
  );
  useEffect(() => {
    setMetricsLocal(JSON.stringify(props.selectedMetrics));
  }, [props.selectedMetrics]);
  return (
    <div
      data-test-section={
        props.isDisabled ? 'events-and-metrics-builder-is-disabled' : ''
      }>
      <textarea
        data-test-section={
          props.disablePrimaryMetricEdit ? 'disable-primary-metric-edit' : ''
        }
        onBlur={e => {
          props.onChange(JSON.parse(metricsLocal));
        }}
        onChange={e => {
          setMetricsLocal(e.target.value);
        }}
        style={{ height: '100px', width: '100%' }}
        value={metricsLocal}
      />
      <button
        className="push-half--top"
        data-test-section="mock-metric"
        onClick={() => props.onChange(MOCK_METRICS)}>
        Add mock metric
      </button>
      <button
        className="push-half--top"
        data-test-section="non-unique-conversion-mock-metric"
        onClick={() => props.onChange(NON_UNIQUE_CONVERSION_MOCK_METRICS)}>
        Add non unique conversion mock metric
      </button>
    </div>
  );
};

export const AudienceLabelMock = (props: {
  audienceIds: number[];
  projectId: number;
}) => {
  const audienceIds = props.audienceIds || [123, 456, 789];
  return (
    <ul>
      {audienceIds.map(audienceId => (
        <li>{audienceId}</li>
      ))}
    </ul>
  );
};

export const AudienceLabelingWrapperMock = (props: {
  projectId: number;
  render: (props: {
    audiencesMap: Record<number, string>;
  }) => React.ReactElement;
}) => {
  return (
    <>
      {props.render({
        audiencesMap: {
          1: 'Audience 1',
          2: 'Audience 2',
          3: 'Audience 3',
        },
      })}
    </>
  );
};

export const AudienceCombinationsBuilderV3 = AudienceCombinationsBuilderWithData;
export const AudienceLabelingWrapper = AudienceLabelingWrapperMock;
export const AudienceLabel = AudienceLabelMock;
export const ProjectName = (props: { projectId?: number | string }) => {
  return <div>{props.projectId}</div>;
};

const OptlyXMocks = {
  AudienceCombinationsBuilderV3,
  AudienceCombinationsBuilderWithData,
  AudienceCombinationsName,
  AudienceLabel,
  AudienceLabelingWrapper,
  AudienceSearchPicker,
  ChangeHistory,
  EventsAndMetricsBuilderWithData,
  ProjectName,
};

export default OptlyXMocks;
